import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

import { Observable }     from 'rxjs/Observable';
// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
//import {TreeModule, TreeNode} from 'primeng/primeng';
//import { contentHeaders } from '../Core/Headers';
import { AuthHttp } from 'angular2-jwt';
import { environment } from '../../environments/environment';

@Injectable()
export class TeamMemberDirectoryService {
    readonly rootUrl = environment.apiEndPoint;
    private headers: Headers;
    private apiUrl: string;
    private actionUrl: string;
    private token: any;

    constructor(private http: Http, private authHttp: AuthHttp) {
        this.headers = new Headers();
        this.token = window.localStorage.getItem('id_token');
    }

    GetTeamMemberDirectory() {
        this.headers.append('Accept', 'application/json');
        this.headers.append('Content-Type', 'application/json');

        this.apiUrl = this.rootUrl + '/api/TeamMemberDirectory/Get';
        return this.authHttp.get(this.apiUrl).map((res: Response) => {
            let data = res.json();
            return data;
        });
    }
}  


// WEBPACK FOOTER //
// ./src/app/Services/team-member-directory.service.ts